import React,{useEffect, useState, useContext} from 'react';
import {MyContext} from '../../login/MyContext';

import Inicio from '../inicio/Inicio';

import MaterialTable from 'material-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';

import Routes from '../../routes/Routes';

function Ver_usuarios() {
  
 const baseUrlAd = Routes.global.url_ver_usuarios; 
 const [data, setData]=useState([]);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id:'',
    name:'',
    apellidos:'',
    documento:'',
    cargo:'',
    celular:'',
    email:'',
    clave:'',
    rol:'',
  });

 
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
  }

 
  const peticionGet =async() =>{
    await axios.get(baseUrlAd)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPut = async() =>{
    var f = new FormData();
    f.append("name", frameworkSeleccionado.name);
    f.append("apellidos", frameworkSeleccionado.apellidos);
    f.append("documento", frameworkSeleccionado.documento);
    f.append("cargo", frameworkSeleccionado.cargo);
    f.append("celular", frameworkSeleccionado.celular);
    f.append("email", frameworkSeleccionado.email);
    f.append("clave", frameworkSeleccionado.clave);
    f.append("METHOD", "PUT_usuarios");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id===frameworkSeleccionado.id){
         framework.name= frameworkSeleccionado.name;
         framework.apellidos= frameworkSeleccionado.apellidos;
         framework.documento= frameworkSeleccionado.documento;
         framework.cargo= frameworkSeleccionado.cargo;
         framework.celular= frameworkSeleccionado.celular;
         framework.email = frameworkSeleccionado.email;
         framework.clave = frameworkSeleccionado.clave;
       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }



  const peticionDelete = async() =>{
    var f = new FormData();
    f.append("METHOD", "DELETE_usuarios");
    await axios.post(baseUrlAd,f, {params: {id: frameworkSeleccionado.id}})
    .then(response=>{
     setData(data.filter(framework=>framework.id!==frameworkSeleccionado.id));
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
    (caso==="Editar")?
    abrirCerrarModalEditar():
    abrirCerrarModalEliminar()
  }

  useEffect(()=>{
    peticionGet();

  },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id",
      
    },
    
    {
      title:"NOMBRES",
      field: "name"
    },

    {
      title:"APELLIDOS",
      field: "apellidos"
    },

    {
      title:"DOCUMENTO",
      field: "documento"
    },

    {
      title:"CELULAR",
      field: "celular"
    },

    {
      title:'EMAIL',
      field:'email'
    },

    {
      title:'ROL',
      field:'rol'
    },

    
    
  ];

  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

  if(isAuth && theUser.rol =="admin")
  {
    return (

        <div className="content-wrapper">
    
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0"></h3>
          </div>
          <div className="col-sm-6">
            
          </div>
        </div>
      </div>
    </div>

   
    <section className="content">
      <div className="container-fluid">
        
        <div className="row">
        
          <div className="col-md-12">

         
            <div>
              
            <MaterialTable

      
     
columns={columnas}
data={data}
title="USUARIOS"
backIconButtonText='Página anterior'
pagination
fixedHeader

actions={[

    {
        icon : 'edit',
        tooltip: 'Editar',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
      },

      {
        icon : 'delete',
        tooltip: 'Eliminar',
         onClick: (event, framework)=>seleccionarFramework(framework, "Eliminar")
      }
    
]}
options={{
  actionsColumnIndex: -1
}}
options={{
 actionsCellStyle: {
   // backgroundColor: "#ffccdd",
   // color: "#FF00dd"
 },

 headerStyle: { backgroundColor: "#55C3F9",  headerStyle: { position: 'sticky'},
 boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white" }
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar',
    
   },

   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}


/>

<Modal isOpen={modalEditar}>
<ModalHeader cssModule={{'modal-title': 'w-100 text-center'}}><i class="fas fa-users-cog" style={{color:"#36BCFE"}}>
 </i> EDITAR USUARIO</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">
   
     <div class="col-5">
     <label>Nombres:</label>
     <br/>
     <input type="text" className="form-control" name="name" onChange={handleChange}  
     value={frameworkSeleccionado && frameworkSeleccionado.name} />
     <br/>
     </div>
     <div class="col-7">
     <label>Apellidos:</label>
     <br/>
     <input type="text" className="form-control" name="apellidos" onChange={handleChange} 
     value={frameworkSeleccionado && frameworkSeleccionado.apellidos} />
     </div>
     <div class="col-6">
     <label>Celular:</label>
     <br/>
     <input type="number" className="form-control" name="celular" onChange={handleChange} 
     value={frameworkSeleccionado && frameworkSeleccionado.celular} />
     </div>
     <div class="col-6">
     <label>Documento:</label>
     <br/>
     <input type="number" className="form-control" name="documento" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.documento} />
     <br/>
     </div>
     <div class="col-12">
     <label>Cargo:</label>
     <br/>
     <input type="text" className="form-control" name="cargo" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.cargo} />
     <br/>
     </div>
     <div class="col-7">
     <label>Email:</label>
     <br/>
     <input type="text" className="form-control" name="email" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.email} />
     <br/>
     </div>
     <div class="col-5">
     <label>Contraseña:</label>
     <br/>
     <input type="text" className="form-control" name="clave" onChange={handleChange}
     />
     <h6><font size="1">mínimo 8 caracteres *</font></h6>
     
     </div>
 

   </div>
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPut()}><i class="fas fa-edit"></i> Editar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalEditar()}>Cancelar</button>
 </ModalFooter>
</Modal>

<Modal isOpen={modalEliminar}>
 <ModalBody>
   ¿Esta seguro que desea eliminar el usuario {frameworkSeleccionado && frameworkSeleccionado.name}?
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-danger"
     onClick={()=>peticionDelete()}
     >
       SI
     </button>
     <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         NO
     </button>

   </ModalFooter>
 

</Modal>

            </div>
          </div>
        </div>
      
      </div>
    </section>
    
  </div>
     )
    }
  
    else if(showLogin){
        return "";
    }
    else{
      return <Inicio/>;
    }
    
    }

export default Ver_usuarios